import _JSON$stringify from '/app/node_modules/babel-runtime/core-js/json/stringify';
import { Bar, mixins } from 'vue-chartjs';
import { mapState } from 'vuex';
var reactiveData = mixins.reactiveData;


export default {
    extends: Bar,
    mixins: [reactiveData],
    computed: mapState({
        barchartData: function barchartData(state) {
            return state.dashboard.table.dataCollection;
        }
    }),
    data: function data() {
        return {
            options: {
                legend: {
                    display: false,

                    label: {
                        fontSize: 8
                    }
                },
                responsive: true,
                scales: {
                    tooltips: {
                        backgroundColor: '#3490e7',
                        titleFontColor: '#fff',
                        tittleFontSize: 0,
                        displayColors: false,
                        yAlign: 'bottom',
                        xPadding: 6
                    },
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            min: 0, //poner variable en cuando haya servicio
                            max: 100, //poner variable en cuando haya servicio
                            stepSize: 20,
                            fontColor: '#BCCBDA',
                            fontSize: 10
                        }
                    }],
                    xAxes: [{
                        ticks: {
                            fontSize: 9,
                            fontColor: '#677A93'
                        },
                        gridLines: {
                            offsetGridLines: true,
                            display: false,
                            zeroLinecolor: 'transparent'
                        },
                        barPercentage: 0.5
                    }],
                    borderWidth: 10
                }
            }
        };
    },

    watch: {
        barchartData: function barchartData(val) {
            this.chartData = JSON.parse(_JSON$stringify(val));
        }
    },
    mounted: function mounted() {
        this.chartData = JSON.parse(_JSON$stringify(this.barchartData));
        this.renderChart(this.chartData, this.options);
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/components/dashboard/barchart.js
// module id = ./src/components/dashboard/barchart.js
// module chunks = 5